import React from "react";
import styled, { keyframes } from "styled-components";
import Modal from "../Modal";
import { Button } from "../Button";
import donePNG from "../../../../images/done.png";

const SuccessModal = ({ open, onClose }) => (
  <Modal open={open}>
    <SuccessContainer>
      {!!open && (
        <React.Fragment>
          <Done />
          <SuccessText>
            <br />
            <h3>Check your email</h3>
            <br />
            It may take a few seconds to process. Do not hesitate to email us at support@topnine.co if you run into
            any issues.
            <br />
            <br />
            Thank you for your support!
            <br />
            <br />
            <Button onClick={onClose}>Got it!</Button>
          </SuccessText>
        </React.Fragment>
      )}
    </SuccessContainer>
  </Modal>
);

const SuccessContainer = styled.div`
  background: white;
  padding: 32px;
  width: 300px;
  display: flex;
  flex-direction: column;
  align-content: center;
`;

const Text = styled.p`
  color: #6e788d;
  font-size: 15px !important;
  font-family: "Montserrat";
  font-weight: 500;
  text-align: left;
  @media (max-width: 640px) {
    font-size: 14px !important;
  }
  b {
    color: #f74255;
  }
`;

const AnimIn = keyframes`
  from {
    transform: scale(0.7);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
`;

const SuccessText = styled(Text)`
  text-align: center;
  animation: ${AnimIn} 0.5s cubic-bezier(0, 0, 0.18, 1.32) forwards;
  margin-bottom: 0px !important;
`;

const Done = styled.img.attrs({ src: donePNG })`
  width: 80px;
  height: 80px;
  margin-left: auto;
  margin-right: auto;
  display: block;
  opacity: 0;
  animation: ${AnimIn} 0.5s cubic-bezier(0, 0, 0.18, 1.32) forwards;
  margin: auto;
`;
export default SuccessModal;
